import styled from 'styled-components';

import Link from '../../../../atoms/link';

export const EditUser = styled(Link)`
  padding: 18px;
`
